<template>
  <div class="bread__crumd__block" v-if="show">
    <div class="el-breadcrumb">
      <span
        v-for="(item, index) in breadCrumbs"
        :key="index"
        class="el-breadcrumb__item"
      >
        <span class="el-breadcrumb__inner is-link" @click="handleClick(item.path, index)">
          {{ item.name }}
        </span>
        <i class="el-breadcrumb__separator el-icon-arrow-right"></i>
      </span>
    </div>
  </div>
</template>
<script>
import EventBus from '../service/EventBus'
export default {
  data() {
    return {
      show: false,
      breadCrumbs: [],
    }
  },
  methods: {
    handleClick(path, index) {
      if (!path || path === '') return
      if (path == '/admin/DocumentsGeneral?tab=VanBanDen') {
        setTimeout(() => {
          this.show = false
          this.breadCrumbs[2] = {
            name: 'Văn bản đến',
            path: '',
          }
          this.show = true
        }, 1000);
        EventBus.$emit('changeTabBreadCrumb', 'VanBanDen')
      }
      this.$router.push({
        path: path,
      }).catch((err) => {console.log('err', err)})
    },
  },
  created() {
    EventBus.$off('breadCrumb')
    EventBus.$on('breadCrumb', (data) => {
      this.show = false
      this.breadCrumbs = data
      this.show = true
    })
  },
}
</script>
<style lang="scss" scoped>
  .bread__crumd__block {
    .el-breadcrumb {
      line-height: 30px;
    }
    padding-left: 10px;
    .el-breadcrumb__item {
      &:last-child {
        white-space: nowrap;
        width: 900px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-breadcrumb__inner {
        font-family: 'LexendDeca Regular';
        font-weight: 400;
        font-size: 18px;
        &.is-link {
          color: #4F8AAB;
          &:hover {
            color: rgb(43, 144, 202);
            font-weight: 500;
          }
        }
      }
      &:last-child {
        .el-breadcrumb__inner {
          color: #444242;
          &:hover {
            color: #444242;
          }
        }
      }
    }
  }
  @media (max-width: 1700px) and (min-width: 1500px) {
    .bread__crumd__block {
      .el-breadcrumb__item {
        &:last-child {
          width: 680px;
        }
      }
    }
  }
  @media (max-width: 1499px) and (min-width: 1340px) {
    .bread__crumd__block {
      .el-breadcrumb__item {
        &:last-child {
          width: 490px;
        }
      }
    }
  }
  @media (max-width: 1339px) and (min-width: 1200px) {
    .bread__crumd__block {
      .el-breadcrumb__item {
        &:last-child {
          width: 390px;
        }
      }
    }
  }
  @media (max-width: 1199px) and (min-width: 1000px) {
    .bread__crumd__block {
      .el-breadcrumb__item {
        &:last-child {
          width: 190px;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    .bread__crumd__block {
      .el-breadcrumb__item {
        &:last-child {
          width: 150px;
        }
      }
    }
  }
  @media (max-width: 1000px) {
    .bread__crumd__block {
      display: none;
    }
  }
</style>
